import { InputNumber } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrInputNumber } from "./ZAttrComponent";

type PropsAttrInputNumber = {
  attrMeta: ZAttrMeta;
  component?: ZAttrInputNumber;
  value?: unknown;
  onChange?(value: unknown): void;
  textCvt?(text: string): string;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  onBlur: () => void;
};

export const AttrInputNumber: React.FC<PropsAttrInputNumber> = observer(
  (props) => {
    const {
      attrMeta,
      component,
      value,
      onChange,
      textCvt,
      disabled,
      activateCallback,
      onBlur,
    } = props;
    const { type } = attrMeta;
    const cvt = (text: string | null | undefined) => {
      if (!text) return undefined;
      return textCvt?.(text) ?? text;
    };
    const ctrlRef = useActivateCallback<HTMLInputElement>(
      activateCallback,
      (ref) => () => ref?.focus(),
    );
    return (
      <InputNumber
        value={value as number}
        ref={ctrlRef}
        onChange={(v) => onChange?.(v)}
        addonAfter={cvt(component?.addonAfter)}
        addonBefore={cvt(component?.addonBefore)}
        precision={
          type.name === "number" ? (type.precision ?? undefined) : undefined
        }
        style={{ width: "100%" }}
        disabled={disabled}
        onBlur={onBlur}
      />
    );
  },
);
